(() => {
  if (window.__cdCustomLoaded) return;
  window.__cdCustomLoaded = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (selector) => document.querySelector(selector);

  function setMessage(text, type) {
    const el = $('#CartDrawer-DiscountMsg');
    if (!el) return;
    el.textContent = text || '';
    el.classList.remove('is-error', 'is-success');
    if (type) el.classList.add('is-' + type);
  }

  async function refreshDrawer() {
    const res = await fetch(root + '?sections=cart-drawer');
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('.drawer__inner');
    const current = $('cart-drawer .drawer__inner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function openDrawer() {
    const drawer = $('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  // Garde le compteur du header et l'etat vide synchronises avec le tiroir
  function syncFromDrawer() {
    const host = $('cart-drawer');
    const countEl = host && host.querySelector('.cd-count');
    if (!countEl) return;
    const n = parseInt(countEl.textContent, 10) || 0;
    host.classList.toggle('is-empty', n === 0);
    document.querySelectorAll(`a[class^='header-cart-'] .cart-count-bubble`).forEach((bubble) => {
      bubble.innerHTML = '';
      if (n < 100) {
        const span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.textContent = '(' + n + ')';
        bubble.appendChild(span);
      }
    });
  }

  const hostEl = $('cart-drawer');
  if (hostEl) {
    new MutationObserver(syncFromDrawer).observe(hostEl, { childList: true, subtree: true, characterData: true });
  }

  // Le header personnalise n'a pas d'element #cart-icon-bubble. Sans ce filtre, Dawn plante a chaque
  // mise a jour du panier (quantite, suppression) et affiche le message d'erreur d'actualisation du panier.
  customElements.whenDefined('cart-drawer-items').then((DrawerItems) => {
    const original = DrawerItems.prototype.getSectionsToRender;
    DrawerItems.prototype.getSectionsToRender = function () {
      return original.call(this).filter((section) => document.getElementById(section.id));
    };
  });

  // Ajout au panier : tout formulaire qui poste vers /cart/add ouvre le tiroir
  // au lieu de rediriger vers la page /cart (phase de capture = passe avant les scripts du theme)
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form || form.tagName !== 'FORM' || !$('cart-drawer')) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return; // le formulaire natif de Dawn gere deja le tiroir

    const formData = new FormData(form);
    const variantId = parseInt(formData.get('id'), 10);
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const buttons = Array.from(form.querySelectorAll('button[type=submit]'));
    const originals = buttons.map((b) => b.innerHTML);
    buttons.forEach((b) => {
      b.disabled = true;
      b.innerHTML = `<span class="atc-text">AJOUT EN COURS...</span>`;
    });

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      if (!res.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: { id: variantId, quantity: parseInt(formData.get('quantity'), 10) || 1 } } }));
      await refreshDrawer();
      syncFromDrawer();
      openDrawer();
    } catch (e) {
      // echec (rupture de stock, reseau...) : on reactive simplement le bouton
    } finally {
      buttons.forEach((b, i) => {
        b.disabled = false;
        b.innerHTML = originals[i];
      });
    }
  }, true);

  async function applyDiscount() {
    const input = $('#CartDrawer-DiscountInput');
    const button = $('#CartDrawer-DiscountApply');
    if (!input || !button) return;

    const code = input.value.trim();
    if (!code) {
      setMessage('Entrez un code de réduction.', 'error');
      return;
    }

    button.disabled = true;
    setMessage('');

    try {
      const res = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      if (!res.ok) throw new Error('update failed');
      const cart = await res.json();

      const titles = [];
      (cart.cart_level_discount_applications || []).forEach((d) => titles.push(String(d.title).toLowerCase()));
      (cart.items || []).forEach((item) => {
        (item.discounts || []).forEach((d) => titles.push(String(d.title).toLowerCase()));
      });
      const applied = titles.indexOf(code.toLowerCase()) !== -1;

      await refreshDrawer();
      if (applied) {
        setMessage('Code appliqué !', 'success');
      } else {
        setMessage('Ce code est invalide ou ne s\'applique pas à votre panier.', 'error');
      }
    } catch (e) {
      setMessage('Impossible d\'appliquer le code pour le moment.', 'error');
      const again = $('#CartDrawer-DiscountApply');
      if (again) again.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('#CartDrawer-DiscountApply')) applyDiscount();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target && event.target.id === 'CartDrawer-DiscountInput') {
      event.preventDefault();
      applyDiscount();
    }
  });
})();
